import { ClientStyle } from 'components/ClientStyle/ClientStyle';
import { I18nHelper } from 'components/TestHelper/components/I18nHelper';

import { PointsHandlerProvider } from 'hooks/usePointsHandler';
import { SettingsProvider } from 'hooks/useSettings';
import { UserInfoProvider } from 'hooks/useUserInfo';

import { queryClient } from './queryClient';

import { QueryClientProvider } from '@tanstack/react-query';

export interface AppContextProps {
  children?: React.ReactNode;
  i18n?: boolean;
}

export function AppContext({ children = null, i18n = false }: AppContextProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <I18nHelper enabled={i18n}>
        <ClientStyle>
          <SettingsProvider>
            <UserInfoProvider>
              <PointsHandlerProvider>
                {children}
              </PointsHandlerProvider>
            </UserInfoProvider>
          </SettingsProvider>
        </ClientStyle>
      </I18nHelper>
    </QueryClientProvider>
  );
}
